var require_constant = require('./constant.cjs');
//#region src/env.ts
var isBrowserEnvValue = typeof ENV_TARGET !== "undefined" ? ENV_TARGET === "web" : typeof window !== "undefined" && typeof window.document !== "undefined";
function isBrowserEnv() {
    return isBrowserEnvValue;
}
function isReactNativeEnv() {
    var _navigator;
    return typeof navigator !== "undefined" && ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.product) === "ReactNative";
}
function isBrowserDebug() {
    try {
        if (isBrowserEnv() && window.localStorage) return Boolean(localStorage.getItem(require_constant.BROWSER_LOG_KEY));
    } catch (error) {
        return false;
    }
    return false;
}
function isDebugMode() {
    if (typeof process !== "undefined" && process.env && process.env["FEDERATION_DEBUG"]) return Boolean(process.env["FEDERATION_DEBUG"]);
    if (typeof FEDERATION_DEBUG !== "undefined" && Boolean(FEDERATION_DEBUG)) return true;
    return isBrowserDebug();
}
var getProcessEnv = function getProcessEnv() {
    return typeof process !== "undefined" && process.env ? process.env : {};
};
//#endregion
exports.getProcessEnv = getProcessEnv;
exports.isBrowserEnv = isBrowserEnv;
exports.isBrowserEnvValue = isBrowserEnvValue;
exports.isDebugMode = isDebugMode;
exports.isReactNativeEnv = isReactNativeEnv; //# sourceMappingURL=env.cjs.map
